import styled from 'styled-components';
import { useTranslations } from '../../hooks/use_translations.js';
import { spacing2x } from '../../styles/spacing.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { IconFileAdd } from '../Icons/IconFileAdd.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var StyledText = styled.div.withConfig({
  displayName: "UploaderInfo__StyledText",
  componentId: "sc-ttrw2y-0"
})(["&&{margin-block-start:", ";font-size:16px;line-height:20px;color:", ";}"], spacing2x, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralColors.charcoal;
});
var UploaderInfo = function UploaderInfo(props) {
  var _props$infoText, _props$limit;
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization,
    neutralColors = _useThemeContext.neutralColors;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx(IconFileAdd, {
      size: 32,
      color: neutralColors.smoke
    }), /*#__PURE__*/jsx(StyledText, {
      "data-testid": "mntl-uploader-info-text",
      children: (_props$infoText = props.infoText) !== null && _props$infoText !== void 0 ? _props$infoText : t("Uploader.dragAndDropInfo", {
        count: "".concat((_props$limit = props.limit) !== null && _props$limit !== void 0 ? _props$limit : 0)
      })
    })]
  });
};

export { UploaderInfo };
